<template>
    <el-dialog :width="config.dialogWidth ? config.dialogWidth : '800px'"
        v-dialogDrag
        :visible.sync="dialogVisible"
        :append-to-body="true"
        @close="dialogClose"
        :close-on-click-modal="config.CloseOnClickModal || false"
        :close-on-press-escape="config.CloseOnPressEscape || false">
        <template v-slot:title>
            <div class="column-config_title">
                {{dialogTitle}}
            </div>
        </template>
        <div class="otp-advance-dialog-container">
            <div class="top-search-group" v-show="!disableSearch">
                <el-form :inline="true" :model="searchObj">
                    <el-form-item>
                        <el-select v-model="searchObj.key" placeholder="请选择">
                            <el-option v-for="option in selectOptions"
                                :key="option.prop"
                                :label="option.value"
                                :value="option.prop"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model.trim="searchObj.keyword" placeholder="请输入" @keyup.enter.native="search" @change="inputChange"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="search">查询</el-button>
                        <el-button @click="reset">重置</el-button>
                    </el-form-item>
                    </el-form>
            </div>
            <el-row :gutter="20">
                <el-col :span="multiple?16:24">
                    <el-table
                        :data="tableData"
                        highlight-current-row
                        v-loading="loading"
                        height="300"
                        :row-class-name="tableRowClassName"
                        :border="config.border ? config.border : false"
                        @current-change="currentRowChange"
                        @row-dblclick="rowDbClick"
                        @row-click="selectionRow">
                        <el-table-column
                            v-for="(column, index) in config.tableConfig"
                            :key="column.prop + index"
                            :prop="column.prop"
                            :label="column.value"
                            :width="column.width"
                            :show-overflow-tooltip="true">
                            <template v-slot="{ row }">
                                <template v-if="column.type === 'select'">{{dictFormat(row[column.prop], column.optionsKey,column.options) }}</template>
                                <template v-else>{{row[column.prop]}}</template>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
                <el-col :span="8" v-if="multiple">
                    <el-table :data="advanceList" class="table-box" height="300" highlight-current-row>
                        <template v-if="config.multipleTableConfig && config.multipleTableConfig.length">
                            <el-table-column
                            v-for="(column, index) in config.multipleTableConfig"
                            :key="column.prop + index"
                            :prop="column.prop"
                            :label="column.value"
                            :width="column.width"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        </template>
                        <el-table-column v-else :prop="config.multipleTableColumn.prop" :label="config.multipleTableColumn.value"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="60">
                            <template v-slot="scope">
                                <el-button class="deleteBtn" @click="deleteDate(scope.$index)" size="small" type='text'>删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <div class="config-footer">
                <el-row>
                    <el-col v-if="mode !== 'EbPlace' && !config.noPagination" :span="3" style="line-height:30px;">共&nbsp;&nbsp;{{pageTotal}}&nbsp;&nbsp;项</el-col>
                    <el-col v-if="mode !== 'EbPlace' && !config.noPagination" :span="16">
                        <el-pagination
                            v-if="!config.noPagination"
                            background
                            class="table-pagination"
                            layout="prev, pager, next"
                            :current-page.sync="page.pageNo"
                            :page-size="page.pageSize"
                            :total="pageTotal"
                            @current-change="currentChange">
                        </el-pagination>
                    </el-col>
                    <el-col :offset="mode === 'EbPlace' || config.noPagination ? 19 : 0" :span="5" style="text-align: right;">
                        <el-button type="text" @click="dialogVisible = false;">取消</el-button>
                        <el-button type="primary" @click="confirm" :disabled="disabledCancel">确定</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import request from '@/utils/http';
import { dictWithUrl } from '../api';
// import { filterSpecChar } from '../utils';
export default {
    props: {
        maxSelect: { // 最多可选数
            type: Number,
            default: 0
        },
        disabledDbClick: {
            type: Boolean,
            default: false
        },
        rejectClose: {
            type: Boolean,
            default: false
        },
        disableSearch: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['currentTenant']),
        selectOptions() {
            return this.config.advanceConfig || this.config.tableConfig;
        },
        dialogTitle() {
            return this.config.advanceLabel || this.config.name || this.config.label;
        },
        maxSelectNumber() {
            return this.maxSelect || this.maxSelectNum;
        }
    },
    data() {
        return {
            maxSelectTip: null,
            disabledCancel: false,
            dialogVisible: false,
            requestMethod: 'get',
            loading: false,
            page: {
                pageSize: 10,
                pageNo: 1
            },
            pageTotal: 0,
            searchObj: {},
            tableData: [],
            config: {},
            multiple: false,
            advanceList: [],
            mode: '',
            optionsData: [],
            maxSelectNum: 0
        };
    },
    watch: {
        dialogVisible(val) {
            if (!val) {
                this.disabledCancel = false;
            }
        }
    },
    methods: {
        async fetchData() {
            this.loading = true;
            let params = {};
            // 对关键字的[]{}符号进行转义
            const keyword = this.requestMethod === 'get' ? this.searchObj.keyword.replace(/{/g, '%7b').replace(/}/g, '%7d').replace(/\[/g, '%5b').replace(/\]/g, '%5d') : this.searchObj.keyword;
            if (this.searchObj.key === 'ALL') {
                params = { ...this.advanceCascade, ...this.page };
                for (let i = 1; i < this.selectOptions.length; i++) {
                    params[this.selectOptions[i].prop] = keyword;
                }
            } else if (this.paramType) {
                params = { ...this.page, param: { ...this.advanceCascade, [this.searchObj.key]: keyword } };
            } else {
                params = { ...this.advanceCascade, ...this.page, [this.searchObj.key]: keyword };
            }
            const reqConfig = {
                method: this.requestMethod,
                url: `${this.prefix}${this.config.advanceUrl}`
            };
            if (this.requestMethod === 'get') {
                reqConfig.params = params;
            } else {
                reqConfig.data = params;
            }
            if (this.hasTenant) {
                reqConfig.headers = { ...reqConfig.headers, tenantCode: this.currentTenant.tenantCode };
            }
            if (this.config.queryConditionRequired && !this.searchObj.keyword) {
                this.$message.warning('查询条件不能为空!');
                this.loading = false;
                return false;
            }
            const res = await request(reqConfig);
            if (res && res.code === '0') {
                if (res.data.totalPage !== 0 && this.page.pageNo > res.data.totalPage) {
                    this.page.pageNo = res.data.totalPage;
                    this.fetchData();
                } else {
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
                if (this.mode === 'EbPlace') { // 处理地区选择时的格式情况
                    this.tableData = res.data;
                }
            } else {
                this.tableData = [];
            }
            this.loading = false;
        },
        show(status = true, config, advanceCascade = {}, mode = '', cache = [], keywords) {
            this.requestMethod = config.method || 'get';
            this.prefix = config.prefix || '/api-mdm/';
            this.hasTenant = config.hasTenant || false;
            this.dialogVisible = status;
            this.paramType = config.paramType || false;
            this.multiple = config.multiple ? config.multiple : false;
            this.maxSelectNum = config.maxSelect || 0;
            if (status === false) return;
            if (!config) {
                this.$message.error('弹窗配置对象为空！');
                return;
            }
            if (this.multiple) {
                this.advanceList = [...cache];
                this.currentRow = cache;
            }
            this.mode = mode;
            this.config = config;
            let initkey = null;
            this.config.cbParams.forEach(itemA => {
                let { 0: sourceProp, 1: destProp } = itemA.split('#');
                destProp = destProp || sourceProp;
                this.selectOptions.forEach(itemB => {
                    if (itemB.prop === sourceProp && this.config.value === destProp) {
                        initkey = itemB.prop; // 下拉框有多个选择匹配选项
                    }
                });
            });
            // this.$set(this.searchObj, 'key', (!this.config.advanceNotSearch && (this.config.advanceReadonly && initkey)) || this.selectOptions[0].prop);
            this.$set(this.searchObj, 'key', (!this.config.advanceNotSearch && this.config.advanceReadonly && initkey) ? initkey : this.selectOptions[0].prop);
            this.$set(this.searchObj, 'keyword', keywords || '');
            this.advanceCascade = advanceCascade;
            this.config.advanceNotSearch || this.fetchData();
            // const keys = _.chain(this.config.tableConfig).map(obj => obj.optionsKey).filter(str => !_.isNil(str)).value();
            const selectKeyCols = _.chain(this.config.tableConfig).filter(obj => obj.optionsKey).value();
            selectKeyCols.forEach(item => {
                if (item.optionsKey) {
                    dictWithUrl(item.optionsKey, item.dictUrl).then(res => {
                        this.$set(item, 'options', res.data[item.optionsKey] || {});
                        // item.options = _.get(res.data, item.optionsKey) || {};
                    });
                }
            });
            // if (keys.length > 0) {
            //     dictWithUrl(keys.join(',')).then(obj => {
            //         if (obj.code === '0') {
            //             this.optionsData = obj.data;
            //         }
            //     });
            // }
        },
        dictFormat(val, optionsKey, options) {
            // if (optionsKey) {
            //     const keyMaps = _.get(this.optionsData, optionsKey);
            //     const optionsKeyValue = _.get(keyMaps, val, val);
            //     return optionsKeyValue;
            // } else if (options) {
            if (options) {
                return _.get(options, val, val);
            } else {
                return val;
            }
        },
        // 行样式
        tableRowClassName ({ row }) {
            if (row.used) {
                return 'grey-row';
            }
        },
        // 页码变化
        currentChange(val) {
            this.page.pageNo = val;
            this.fetchData();
        },
        // 搜索
        search() {
            this.page.pageNo = 1;
            this.fetchData();
        },
        // 重置
        reset() {
            this.searchObj.keyword = '';
            this.advanceList = [];
            this.config.advanceNotSearch || this.fetchData();
        },
        // 表格
        currentRowChange(row) {
            if (row && !row.used) {
                this.currentRow = row;
            }
        },
        // 表格双击
        rowDbClick(row) {
            if (this.disabledDbClick) return false;
            if (row.used) return false;
            this._emitResult(row);
        },
        confirm() {
            if (!this.currentRow) {
                this.$message.warning('没选中数据');
                return;
            }
            this._emitResult(this.currentRow);
        },
        // 返回选中值
        _emitResult(row) {
            const data = {};
            if (!this.config.cbParams) {
                this.$message.error('弹窗没定义cbParams配置!');
                return;
            }
            if (this.multiple) {
                let searchData = {};
                this.config.tableConfig.forEach(item => {
                    searchData[item.prop] = [];
                    this.advanceList.map(aitem => {
                        searchData[item.prop].push(aitem[item.prop]);
                    });
                    row[item.prop] = searchData[item.prop].join(',');
                });
            }
            for (const item of this.config.cbParams) {
                let { 0: sourceProp, 1: destProp } = item.split('#');
                destProp = destProp || sourceProp;
                data[destProp] = row[sourceProp];
            }
            this.$emit('confirm', data, this.config);
            if (this.rejectClose) {
                this.disabledCancel = true;
                return false;
            }
            this.dialogVisible = false;
        },
        inputChange(val) { },
        dialogClose() {
            // 重置属性
            this.page = {
                pageSize: 10,
                pageNo: 1
            };
            this.pageTotal = 0;
            this.searchObj = {};
            this.tableData = [];
            this.$emit('close');
        },
        deleteDate(index) {
            this.advanceList.splice(index, 1);
        },
        selectionRow(currentRow) {
            if (this.multiple) {
                if (this.advanceList.includes(currentRow)) {
                    return;
                }
                if (this.maxSelectNumber > 0 && this.advanceList.length >= this.maxSelectNumber) {
                    this.maxSelectTip && this.maxSelectTip.close();
                    this.maxSelectTip = this.$message.warning(`最多可选 ${this.maxSelectNumber} 项!`);
                    return;
                }
                let num = 0;
                this.advanceList.map(item => {
                    if (item[this.config.tableConfig[0].prop] === currentRow[this.config.tableConfig[0].prop] &&
                    item[this.config.tableConfig[1].prop] === currentRow[this.config.tableConfig[1].prop]) {
                        num += 1;
                    }
                });
                if (num === 0) {
                    this.advanceList.push(currentRow);
                }
            } else {
                this.advanceList = currentRow;
            }
        }
    }
};

</script>

<style lang="less">
.column-config_title{
    small{
        margin-left: 25px;
    }
}
.otp-advance-dialog-container {
    .config-footer {
        margin-top: 18px;
    }
    .table-pagination{
        float: right;
        padding: 0;
        .el-pager li.active + li {
            border-left: 1px solid #cccccc;
        }
        .el-pager li:not(.disabled).active{
            border: 1px solid #00BCBF;
        }
    }
    .el-pagination.is-background{
        .btn-prev, .btn-next, .el-pager li{
            background-color: #ffffff;
            border: 1px solid #cccccc;
            border-radius: 4px;
        }
    }
    .el-table__body tr.grey-row>td {
            background: rgb(214, 214, 212);
        }
}
</style>
